const VISITOR_KEY = "ms_behavior_visitor";
const SESSION_KEY = "ms_behavior_session";

function token(prefix: string) {
  const rand = typeof crypto !== "undefined" && crypto.randomUUID
    ? crypto.randomUUID().replace(/-/g, "")
    : `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 12)}`;
  return `${prefix}_${rand.slice(0, 24)}`;
}

export function visitorId() {
  try {
    const existing = localStorage.getItem(VISITOR_KEY);
    if (existing)
      return existing;
    const next = token("v");
    localStorage.setItem(VISITOR_KEY, next);
    return next;
  }
  catch {
    return token("v");
  }
}

export function sessionId() {
  try {
    const existing = sessionStorage.getItem(SESSION_KEY);
    if (existing)
      return existing;
    const next = token("s");
    sessionStorage.setItem(SESSION_KEY, next);
    return next;
  }
  catch {
    return token("s");
  }
}
